export const DOWNLOADS_BASE_URL =
  import.meta.env.VITE_DOWNLOADS_BASE_URL || "https://media.evtcc.org/downloads";

/**
 * Returns the resolved URL for an EVTCC download asset.
 * If path is already an absolute URL (http/https), returns as-is.
 * Strips leading slashes and optional 'downloads/' prefix.
 */
export function getDownloadUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const cleanPath = path.replace(/^\/?(downloads\/)?/, "");
  const baseUrl = DOWNLOADS_BASE_URL.replace(/\/+$/, "");
  return `${baseUrl}/${cleanPath}`;
}
